import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Suspense, lazy, useEffect } from 'react'
import { ClientOnly } from '@tanstack/react-router'
import { LoadingScreen } from '../components/ui/LoadingScreen'
import { useBetterAuth } from '../contexts/BetterAuthContext'

// Leaflet reads `window` while its module is evaluated, so it must stay out of
// the server bundle entirely. ClientOnly only defers rendering — the lazy()
// boundary is what keeps the import off the server.
const MapComponent = lazy(() => import('../components/HomeMap'))

export const Route = createFileRoute('/')({
  component: HomePage,
})

function HomePage() {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useBetterAuth()

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate({ to: '/login' })
    }
  }, [isAuthenticated, isLoading, navigate])

  // Show loading while checking auth
  if (isLoading || !isAuthenticated) {
    return <LoadingScreen message="Checking authentication" />
  }

  return (
    <div className="h-screen w-full">
      <ClientOnly fallback={<LoadingScreen message="Loading map" />}>
        <Suspense fallback={<LoadingScreen message="Loading map" />}>
          <MapComponent />
        </Suspense>
      </ClientOnly>
    </div>
  )
}
